<template>
  <v-container class="col-12">
    <v-card class="pa-4 mt-4">

      <v-data-table
        :loading="limits.loading"
        :headers="headers"
        :items="limits.items"
        hide-default-footer
        style="z-index: 0; position: relative;"
      >
        <template v-slot:item.type="{ item, header }">
          {{ beautifyType(item.type) }}
        </template>
        <template v-slot:item.activated="{ item, header }">
          {{ beautifyDate(item.activated) }}
        </template>
        <template v-slot:item.delete_on="{ item, header }">
          {{ beautifyDate(item.delete_on) }}
        </template>
        <template v-slot:item.limit="{ item, header }">
          <v-text-field
            v-if="item.type === TYPE_EXCLUSION"
            class="pa-0 ma-0"
            :value="getExcludedUntil(item.expire)"
            style="max-width: 200px;"
            readonly
            hide-details
          />
          <v-text-field
            v-else
            v-model="item.limit"
            class="pa-0 ma-0"
            style="max-width: 200px;"
            :readonly="item.type === TYPE_EXCLUSION"
            hide-details
          ></v-text-field>
        </template>
        <template v-slot:item.period="{ item, header }">
          <v-select
            v-model="item.period"
            :items="periods[item.type] || periods.default"
            class="pa-0 ma-0"
            style="max-width: 250px;"
            hide-details
          />
        </template>
        <!--        <template v-slot:header.activated="{ item, header }">-->
        <!--          <v-row>-->
        <!--            {{ header.text }}-->
        <!--            <v-spacer/>-->
        <!--            <v-btn @click="$store.dispatch('account/saveLimits', activeAccount.account)" icon>-->
        <!--              <v-icon>save</v-icon>-->
        <!--            </v-btn>-->
        <!--            <v-btn @click="$store.dispatch('account/loadLimits', activeAccount.account)" icon>-->
        <!--              <v-icon>refresh</v-icon>-->
        <!--            </v-btn>-->
        <!--          </v-row>-->
        <!--        </template>-->


        <template v-slot:header.action="{ item, header }">
          <v-btn @click="$store.dispatch('account/loadLimits', activeAccount.account)" icon class="float-right">
            <v-icon>refresh</v-icon>
          </v-btn>
          <!--          <v-row>-->
          <!--            <v-spacer />-->
          <!--            <v-btn @click="$store.dispatch('account/saveLimits', activeAccount.account)" icon>-->
          <!--              <v-icon>save</v-icon>-->
          <!--            </v-btn>-->
          <!--            <v-btn @click="$store.dispatch('account/loadLimits', activeAccount.account)" icon>-->
          <!--              <v-icon>refresh</v-icon>-->
          <!--            </v-btn>-->
          <!--          </v-row>-->
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn @click="update(item, 'set')" icon class="float-right">
            <v-icon>save</v-icon>
          </v-btn>
          <v-btn @click="update(item, 'cancel')" icon class="float-right">
            <v-icon>cancel</v-icon>
          </v-btn>
          <v-btn @click="update(item, 'delete')" icon class="float-right">
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<style>

</style>

<script>
  import { capitalize, pick, toNumber } from 'lodash'
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import { API } from '@/utils/api'

  export default {

    components: {},

    props: [],
    data: () => ({
      periods: {
        reality_check: [
          { text: '15 minutes', value: '15 minutes' },
          { text: '30 minutes', value: '30 minutes' },
          { text: '45 minutes', value: '45 minutes' },
          { text: '60 minutes', value: '60 minutes' },
        ],
        exclusion: [
          { text: '1 hour', value: '1 h', },
          { text: '12 hours', value: '12 h', },
          { text: '1 day', value: '1 day', },
          { text: '3 days', value: '3 days', },
          { text: '1 week', value: '1 week', },
          { text: '1 month', value: '1 month', },
          { text: '3 month', value: '3 month', },
          { text: '6 month', value: '6 month', },
          { text: 'Indefinite', value: 'undefinite.time', },
        ],
        default: [
          { text: '15 minutes', value: '15 minutes' },
          { text: '30 minutes', value: '30 minutes' },
          { text: '45 minutes', value: '45 minutes' },
          { text: '60 minutes', value: '60 minutes' },
          { text: 'Daily', value: '1 days' },
          { text: 'Weekly', value: '1 weeks' },
          { text: 'Monthly', value: '1 months' },
        ],
      },
      tableOptionAID: null,
      menuFrom: null,
      menuTo: null,
      headers: [
        { text: 'Type', value: 'type', 'class': 'nowrap', sortable: false },
        { text: 'Limit', value: 'limit', 'class': 'nowrap', sortable: false },
        { text: 'Period', value: 'period', 'class': 'nowrap', sortable: false },
        { text: 'New Limit', value: 'new_rules.limit', 'class': 'nowrap', sortable: false },
        { text: 'New Period', value: 'new_rules.period', 'class': 'nowrap', sortable: false },
        { text: 'Activated', value: 'activated', 'class': 'nowrap', sortable: false },
        { text: 'Delete On', value: 'delete_on', 'class': 'nowrap', sortable: false },
        { text: '', value: 'action', 'class': 'nowrap', sortable: false },
      ],
      TYPE_EXCLUSION: 'exclusion'
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active', limits: 'account/limits' }),
    },

    methods: {

      beautifyDate (date) {
        if (!date) return ''
        return moment(date * 1000).utc().format('YYYY-MM-DD HH:mm:ss')
      },
      beautifyType (type) {
        return capitalize(type.replace('_', ' '))
      },

      search: function () {
        this.$store.dispatch('account/loadLimits', this.activeAccount.account).catch(e => {
          this.$notification.show = true
          this.$notification.message = e.response.data.message
          this.$notification.type = 'error'
        })
      },
      update: async function (item, action) {

        let buttons = [
          { text: 'Yes', value: true, class: 'primary darken-1' },
          { text: 'Yes, forced', value: 'forced', class: 'primary darken-1' },
          { text: 'Cancel', value: false, class: 'grey' },
        ]

        let confirmRes = await this.$root.$confirm('Confirm', `Are you sure you want to ${action} this item?`, { width: 565, buttons })

        if (confirmRes) {

          if (item.amount) {
            item.amount = toNumber(item.amount)
          }

          return API.call('/$v/account/limits/update.json', {
            action,
            account_id: this.activeAccount.account.account_id,
            ...(confirmRes == 'forced' ? { forced: true } : { forced: false }),
            ...pick(item, [ 'type', 'amount', 'limit', 'period' ])
          }, this.activeAccount.account).then(r => {
            this.search()
          })
        }
      },

      getExcludedUntil(timestamp) {
        if (!timestamp) {
          return '-'
        }

        return moment(timestamp * 1000).format('YYYY-MM-DD')
      }
    },
  }
</script>
